import React, { useContext, useState } from "react";
import { AppContext } from "../../context/AppContext";
import ApiConfig from "../../api/ApiConfig";
import { simpleGetCallWithErrorResponse } from "../../api/ApiServices";
import FileSaver from "file-saver";
import Loader from "../Loader";
import ExcelLoader from "../../sharedComponent/ExcelLoader";
import BookIcon from "../../assets/images/ic_excel.svg";
import { ToastMsg } from "../TostMsg";

const MONTHS = [
  { value: 1, label: "January" },
  { value: 2, label: "February" },
  { value: 3, label: "March" },
  { value: 4, label: "April" },
  { value: 5, label: "May" },
  { value: 6, label: "June" },
  { value: 7, label: "July" },
  { value: 8, label: "August" },
  { value: 9, label: "September" },
  { value: 10, label: "October" },
  { value: 11, label: "November" },
  { value: 12, label: "December" },
];

const buildYearList = () => {
  const current = new Date().getFullYear();
  const years = [];
  for (let i = 0; i < 6; i++) years.push(current - i);
  return years;
};

const SettlementReport = () => {
  const { sidebar } = useContext(AppContext);

  const now = new Date();
  const [filter, setFilter] = useState({
    month: now.getMonth() + 1,
    year: now.getFullYear(),
  });
  const [excelLoading, setExcelLoading] = useState(false);

  const yearList = buildYearList();

  const downloadSettlementReport = () => {
    setExcelLoading(true);
    const url =
      ApiConfig.GET_SETTLEMENT_REPORT +
      `?month=${filter.month}&year=${filter.year}&isexport=true`;

    simpleGetCallWithErrorResponse(url)
      .then((res) => {
        if (res?.json?.Success && res.json.Data) {
          const monthLabel =
            MONTHS.find((m) => m.value === filter.month)?.label || filter.month;
          FileSaver.saveAs(
            "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
              res.json.Data,
            `Settlement_Report_${monthLabel}_${filter.year}.xlsx`
          );
        } else {
          ToastMsg("error", res?.json?.Message || "Failed to generate report");
        }
      })
      .catch(() => {
        ToastMsg("error", "Something went wrong");
      })
      .finally(() => setExcelLoading(false));
  };

  return (
    <div
      className={sidebar ? "taskMain " : "cx-active taskMain"}
      id="cx-main"
    >
      <div className="role-content-main">
        <div className="sub-header-role mb-4">
          <h6 className="mt-2">Settlement Report</h6>
        </div>

        <div className="d-flex justify-content-between mb-4 mainHeader">
          <div className="role-table-header-main">
            <div className="search-input-wrapper-main">
              <select
                className="form-select input-select-option"
                value={filter.year}
                onChange={(e) =>
                  setFilter((prev) => ({
                    ...prev,
                    year: Number(e.target.value),
                  }))
                }
              >
                {yearList.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>

            <div className="search-input-wrapper-main mx-4">
              <select
                className="form-select input-select-option"
                value={filter.month}
                onChange={(e) =>
                  setFilter((prev) => ({
                    ...prev,
                    month: Number(e.target.value),
                  }))
                }
              >
                {MONTHS.map((m) => (
                  <option key={m.value} value={m.value}>
                    {m.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="d-flex justify-content-between mainIcons">
            <div className="booksIcon" style={{ textAlign: "center" }}>
              {excelLoading ? (
                <ExcelLoader />
              ) : (
                <img
                  src={BookIcon}
                  className="innerIconsBtn"
                  alt="Export"
                  title="Download Settlement Report"
                  onClick={downloadSettlementReport}
                />
              )}
            </div>
          </div>
        </div>

        <div className="empolyDetails mb-4">
          <div className="employeeDet">
            <div className="mb-2">
              <p className="detailHead">Settlement Period</p>
              <div className="middleLine mt-1"></div>
            </div>
            <div className="row">
              <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
                <label className="detailLabel">Month</label>
                <p className="detailText">
                  {MONTHS.find((m) => m.value === filter.month)?.label}
                </p>
              </div>
              <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
                <label className="detailLabel">Year</label>
                <p className="detailText">{filter.year}</p>
              </div>
            </div>
            <div className="mt-2" style={{ color: "#6b7280", fontSize: 13 }}>
              Pick the month and year above and click the export icon to
              download the Razorpay settlement report as an Excel file.
            </div>
          </div>
        </div>

        {excelLoading && <Loader />}
      </div>
    </div>
  );
};

export default SettlementReport;
